(function () {
    'use strict';

    angular.module("imApp").factory("businessSiteService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1656,
                    parameters: parms || {}
                });
            },
            listStockPlaces: function (parms) {
                return $ihttp.post({
                    method: 1658,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1657,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
